import { Component, Input } from "@angular/core";
import { InputManager } from "../game-engine/input-manager";
var SkillButton = (function () {
    function SkillButton(input_manager_) {
        this.input_manager_ = input_manager_;
    }
    ;
    SkillButton.prototype.handleMouseDown = function (event) {
        event.stopPropagation();
        var div = event.target;
        console.log("skill button: " + this.keybind + ", event target: " + div.id);
    };
    SkillButton.decorators = [
        { type: Component, args: [{
                    selector: "skill-button",
                    template: "\n    <div class=\"skill-button\" (mousedown)=\"handleMouseDown($event)\">\n        <p>{{keybind}}</p>\n    </div>\n    ",
                    styles: ["\n    .skill-button {\n        color: cyan;\n        font-size: 16px;\n        display: inline-block;\n        float: left;\n        width: 20%;\n        height: 100%;\n        border: 0.25em solid white;\n        margin: 0;     \n        z-index: 15;\n    }\n    "]
                },] },
    ];
    SkillButton.ctorParameters = function () { return [
        { type: InputManager, },
    ]; };
    SkillButton.propDecorators = {
        "keybind": [{ type: Input },],
    };
    return SkillButton;
}());
export { SkillButton };
;
//# sourceMappingURL=skill-button.component.js.map